module.exports = __webpack_public_path__ + "media/images/flags/4x3/lva-458e99b777585ed69025b258907e048d.svg";